import { InfectionEvolutionStatus, InfectionLevel } from '../tavmills';
import mockedRequester from './mockedRequester';
const episodeValues = () => Array.from({ length: 116 }, (_, i) => {
    const T = i * 0.9;
    return { T, LW_D: T * 1.4 };
});
const episode = {
    start: '1638433318',
    end: '1638433418',
    firstAppleScabbingDate: '1638433320',
    distance: 0.5,
    isMissingData: false,
    values: episodeValues(),
    status: InfectionEvolutionStatus.current,
    level: InfectionLevel.medium,
    degreeHourCumul: 261
};
export const mockedResults = [
    episode,
    {
        ...episode,
        end: null,
        firstAppleScabbingDate: null,
        values: episodeValues(),
        degreeHourCumul: 267
    },
    {
        ...episode,
        values: episodeValues(),
        start: '1638423318',
        end: '1638423418',
        degreeHourCumul: 270
    },
    {
        ...episode,
        values: episodeValues(),
        start: '1638413318',
        end: '1638413418',
        degreeHourCumul: 271
    },
    {
        ...episode,
        values: episodeValues(),
        start: '1638333318',
        end: '1638333418',
        degreeHourCumul: 273
    }
];
const mock = {
    constants: mockedRequester({
        [InfectionLevel.light]: [{ T: 5, LW_D: 5 }],
        [InfectionLevel.medium]: [{ T: 12, LW_D: 20 }],
        [InfectionLevel.severe]: [{ T: 10, LW_D: 54 }]
    }, 'tavmills.constants'),
    results: mockedRequester(mockedResults, 'tavmills.results')
};
export default mock;
